"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var global_1 = require("../../base/global");
var layer_1 = tslib_1.__importDefault(require("../stack-bar/layer"));
var data_1 = require("../../util/data");
var PercentageStackBarLayer = /** @class */ (function (_super) {
    tslib_1.__extends(PercentageStackBarLayer, _super);
    function PercentageStackBarLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'percentageStackBar';
        return _this;
    }
    PercentageStackBarLayer.getDefaultOptions = function () {
        return _.deepMix({}, _super.getDefaultOptions.call(this), {
            xAxis: {
                visible: true,
                tickLine: {
                    visible: false,
                },
                grid: {
                    visible: false,
                },
                title: {
                    visible: true,
                    formatter: function (v) { return v + " (%)"; },
                },
                label: {
                    visible: false,
                    formatter: function (v) {
                        var reg = /%/gi;
                        return v.replace(reg, '');
                    },
                },
            },
        });
    };
    PercentageStackBarLayer.prototype.processData = function (originData) {
        var _a = this.options, xField = _a.xField, yField = _a.yField;
        var processData = _super.prototype.processData.call(this, originData);
        return data_1.transformDataPercentage(processData, yField, [xField]);
    };
    PercentageStackBarLayer.prototype.scale = function () {
        var metaConfig = {};
        var xField = this.options.xField;
        metaConfig[xField] = {
            tickCount: 6,
            alias: xField + " (%)",
            min: 0,
            max: 1,
            formatter: function (v) {
                var formattedValue = (v * 100).toFixed(1);
                return formattedValue + "%";
            },
        };
        this.options.meta = metaConfig;
        _super.prototype.scale.call(this);
    };
    return PercentageStackBarLayer;
}(layer_1.default));
exports.default = PercentageStackBarLayer;
global_1.registerPlotType('percentageStackBar', PercentageStackBarLayer);
//# sourceMappingURL=layer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/percentage-stack-bar/layer.js
// module id = 942
// module chunks = 37